var map = {
	"./channels/channels.module": [
		"+AQk",
		0,
		2
	],
	"./page-not-found/page-not-found.module": [
		"blFi",
		3
	],
	"./partners/partners.module": [
		"DBNS",
		0,
		1
	],
	"./services/services.module": [
		"+jIx",
		4
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "gFIY";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/$$_gendir lazy
// module id = gFIY
// module chunks = 6